/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { QaEquipmentCatalogDto } from './QaEquipmentCatalogDto';
import {
    QaEquipmentCatalogDtoFromJSON,
    QaEquipmentCatalogDtoFromJSONTyped,
    QaEquipmentCatalogDtoToJSON,
} from './QaEquipmentCatalogDto';

/**
 * 
 * @export
 * @interface QaEquipmentItemGroupDto
 */
export interface QaEquipmentItemGroupDto {
    /**
     * 
     * @type {string}
     * @memberof QaEquipmentItemGroupDto
     */
    name?: string | null;
    /**
     * 
     * @type {Array<QaEquipmentCatalogDto>}
     * @memberof QaEquipmentItemGroupDto
     */
    items?: Array<QaEquipmentCatalogDto> | null;
    /**
     * 
     * @type {string}
     * @memberof QaEquipmentItemGroupDto
     */
    groupHash?: string | null;
    /**
     * 
     * @type {string}
     * @memberof QaEquipmentItemGroupDto
     */
    $type?: QaEquipmentItemGroupDtoTypeEnum;
}


/**
 * @export
 */
export const QaEquipmentItemGroupDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedResultsDtoQaEquipmentItemGroupDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.Results.Dto.QaEquipmentItemGroupDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type QaEquipmentItemGroupDtoTypeEnum = typeof QaEquipmentItemGroupDtoTypeEnum[keyof typeof QaEquipmentItemGroupDtoTypeEnum];


/**
 * Check if a given object implements the QaEquipmentItemGroupDto interface.
 */
export function instanceOfQaEquipmentItemGroupDto(value?: unknown): value is QaEquipmentItemGroupDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(QaEquipmentItemGroupDtoTypeEnum)[0];
}

export function QaEquipmentItemGroupDtoFromJSON(json: any): QaEquipmentItemGroupDto {
    return QaEquipmentItemGroupDtoFromJSONTyped(json, false);
}

export function QaEquipmentItemGroupDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): QaEquipmentItemGroupDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'items': !exists(json, 'items') ? undefined : (json['items'] === null ? null : (json['items'] as Array<any>).map(QaEquipmentCatalogDtoFromJSON)),
        'groupHash': !exists(json, 'groupHash') ? undefined : json['groupHash'],
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function QaEquipmentItemGroupDtoToJSON(value?: QaEquipmentItemGroupDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'name': value.name,
        'items': value.items === undefined ? undefined : (value.items === null ? null : (value.items as Array<any>).map(QaEquipmentCatalogDtoToJSON)),
        'groupHash': value.groupHash,
        '$type': value.$type,
    });
}

